export default __webpack_public_path__ + "/dist/images/Free.dd76437bf0bc72dc69ad3ef6f7c2684f.svg";